import { Component, HostListener, OnInit } from '@angular/core';
import { ThemeOptions } from '../../../theme-options';
import { select } from '@angular-redux/store';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { MENU_KEY } from 'src/app/Constants/main-keys';
import { TranslationService } from 'src/app/Services/translation.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent implements OnInit {
  isMenuLoaded: boolean;
  menu: Array<any> = [];
  public extraParameter: any;

  constructor(
    public globals: ThemeOptions,
    private activatedRoute: ActivatedRoute,
    private translationService: TranslationService
  ) { }

  @select('config') public config$: Observable<any>;

  private newInnerWidth: number;
  private innerWidth: number;
  activeId = 'dashboardsMenu';

  toggleSidebar() {
    this.globals.toggleSidebar = !this.globals.toggleSidebar;
  }

  sidebarHover() {
    this.globals.sidebarHover = !this.globals.sidebarHover;
  }

  ngOnInit() {
    setTimeout(() => {
      this.innerWidth = window.innerWidth;
      if (this.innerWidth < 1200) {
        this.globals.toggleSidebar = true;
      }
    });

    this.extraParameter = this.activatedRoute.snapshot.firstChild.data.extraParameter;

    this.menu = JSON.parse(localStorage.getItem(MENU_KEY));
    this.menu.forEach(data => {
      if (data.name) {
        this.translationService.translatePages(data.name).subscribe(translatedName => {
          if (translatedName) {
            data.name = translatedName;
          }
          this.isMenuLoaded = data.name === this.menu[this.menu.length - 1].name;
          if (data.children.length) {
            data.children.forEach(children => {
              if (children.name) {
                this.translationService.translatePages(children.name).subscribe(translatedChildName => {
                  if (translatedChildName) {
                    children.name = translatedChildName;
                  }
                });
              }
            });
          }
        });
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.newInnerWidth = event.target.innerWidth;

    if (this.newInnerWidth < 1200) {
      this.globals.toggleSidebar = true;
    } else {
      this.globals.toggleSidebar = false;
    }
  }
}
